export default "__VITE_ASSET__DDmzpBqM__"